export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

export const CLEAR_DATA = 'CLEAR_DATA';
export const CLEAR_WORLD_DATA = 'CLEAR_WORLD_DATA';
export const CLEAR_ALL_COUNTRIES_COVID_DATA_NAME_ORDERED_DATA = 'CLEAR_ALL_COUNTRIES_COVID_DATA_NAME_ORDERED_DATA';
export const CLEAR_ALL_COUNTRIES_COVID_DATA = 'CLEAR_ALL_COUNTRIES_COVID_DATA';
export const CLEAR_COUNTRY_ISO_BASED_DATA = 'CLEAR_COUNTRY_ISO_BASED_DATA';
export const CLEAR_COUNTRY_STATES_AND_CITIES_DATA = 'CLEAR_COUNTRY_STATES_AND_CITIES_DATA';
export const CLEAR_PROVINCE_ISO_REPORT_DATA = 'CLEAR_PROVINCE_ISO_REPORT_DATA';
export const CLEAR_CITIES_ISO_REPORT_DATA = 'CLEAR_CITIES_ISO_REPORT_DATA';
export const CLEAR_OVID_DATA = 'CLEAR_OVID_DATA';
export const CLEAR_COUNTRIES_DATA = 'CLEAR_COUNTRIES_DATA';
export const CLEAR_PROVINCES_DATA = 'CLEAR_PROVINCES_DATA';

export const NEWS_LOADING = 'PROFILE_LOADING';
export const GET_NEWS = 'GET_ERRORS';
export const GET_VACCINE_NEWS = 'GET_VACCINE_NEWS';
export const GET_NEXT_VACCINE_NEWS = 'GET_NEXT_VACCINE_NEWS';
export const GET_PREVIOUS_VACCINE_NEWS = 'GET_PREVIOUS_VACCINE_NEWS';
export const GET_CORONAVIRUS_NEWS = 'GET_CORONAVIRUS_NEWS';
export const GET_NEXT_CORONAVIRUS_NEWS = 'GET_NEXT_CORONAVIRUS_NEWS';
export const GET_PREVIOUS_CORONAVIRUS_NEWS = 'GET_PREVIOUS_CORONAVIRUS_NEWS';
export const GET_HEALTH_NEWS = 'GET_HEALTH_NEWS';
export const GET_NEXT_HEALTH_NEWS = 'GET_NEXT_HEALTH_NEWS';
export const GET_PREVIOUS_HEALTH_NEWS = 'GET_PREVIOUS_HEALTH_NEWS';

export const GET_WORLD_COVID_DATA = 'GET_WORLD_COVID_DATA';
export const GET_ALL_COUNTRIES_COVID_DATA = 'GET_ALL_COUNTRIES_COVID_DATA';

export const GET_ASIA_COUNTRIES_COVID_DATA = 'GET_ASIA_COUNTRIES_COVID_DATA';
export const GET_AFRICA_COUNTRIES_COVID_DATA = 'GET_AFRICA_COUNTRIES_COVID_DATA';
export const GET_EUROPE_COUNTRIES_COVID_DATA = 'GET_EUROPE_COUNTRIES_COVID_DATA';
export const GET_NORTH_AMERICA_COUNTRIES_COVID_DATA = 'GET_NORTH_AMERICA_COUNTRIES_COVID_DATA';
export const GET_SOUTH_AMERICA_COUNTRIES_COVID_DATA = 'GET_SOUTH_AMERICA_COUNTRIES_COVID_DATA';
export const GET_AUSTRALIA_OCEANIA_COUNTRIES_COVID_DATA = 'GET_AUSTRALIA_OCEANIA_COUNTRIES_COVID_DATA';

export const GET_ALL_COUNTRIES_COVID_DATA_NAME_ORDERED = 'GET_ALL_COUNTRIES_COVID_DATA_NAME_ORDERED';
export const GET_COUNTRY_ISO_BASED_DATA = 'GET_COUNTRY_ISO_BASED_DATA';
export const GET_COUNTRY_STATES_AND_CITIES_DATA = 'GET_COUNTRY_STATES_AND_CITIES_DATA';
export const GET_PROVINCE_ISO_REPORT_DATA = 'GET_PROVINCE_ISO_REPORT_DATA';
export const GET_CITIES_ISO_REPORT_DATA = 'GET_CITIES_ISO_REPORT_DATA';

export const GET_USA_STATES_DATA = 'GET_USA_STATES_DATA';
export const GET_CANADA_STATES_DATA = 'GET_CANADA_STATES_DATA';
export const GET_BRAZIL_STATES_DATA = 'GET_BRAZIL_STATES_DATA';
export const GET_GERMANY_STATES_DATA = 'GET_GERMANY_STATES_DATA';
export const GET_AUSTRALIA_STATES_DATA = 'GET_AUSTRALIA_STATES_DATA';

export const GET_OVID_DATA = 'GET_OVID_DATA';

export const GET_ALL_VACCINES = 'GET_ALL_VACCINES';
export const GET_ALL_VACCINES_PRE_CLINICAL = 'GET_ALL_VACCINES_PRE_CLINICAL';
export const GET_ALL_VACCINES_PHASE_ONE = 'GET_ALL_VACCINES_PHASE_ONE';
export const GET_ALL_VACCINES_PHASE_TWO = 'GET_ALL_VACCINES_PHASE_TWO';
export const GET_ALL_VACCINES_PHASE_THREE = 'GET_ALL_VACCINES_PHASE_THREE';
export const GET_ALL_VACCINES_PHASE_FOUR = 'GET_ALL_VACCINES_PHASE_FOUR';
export const GET_FDA_APPROVED_VACCINES = 'GET_FDA_APPROVED_VACCINES';
export const GET_VACCINES_CATEGORY_BASED = 'GET_VACCINES_CATEGORY_BASED';

export const GET_ALL_TREATMENTS = 'GET_ALL_TREATMENTS';
export const GET_ALL_TREATMENTS_PRE_CLINICAL = 'GET_ALL_TREATMENTS_PRE_CLINICAL';
export const GET_ALL_TREATMENTS_CLINICAL = 'GET_ALL_TREATMENTS_CLINICAL';
export const GET_ALL_TREATMENTS_FDA_APPROVED = 'GET_ALL_TREATMENTS_FDA_APPROVED';
export const GET_TREATMENTS_CATEGORY_BASED = 'GET_TREATMENTS_CATEGORY_BASED';

export const CLEAR_VACCINE_DATA = 'CLEAR_VACCINE_DATA';
export const CLEAR_TREATMENT_DATA = 'CLEAR_TREATMENT_DATA';
export const CLEAR_EACH_VACCINE = 'CLEAR_EACH_VACCINE';

export const GET_EACH = 'GET_EACH';
